<section class="index h-75 d-flex">
  <div class="container container-index">
    <div *ngIf="allSchedules && allSchedules.length > 0" class="row justify-content-around">
      <div *ngFor="let schedule of allSchedules" class="schedule-list-block col-lg-6">
        <app-schedule [schedule]="schedule"></app-schedule>
      </div>
    </div>
  </div>
</section>
